import { render, staticRenderFns } from "./AdminTripForm.vue?vue&type=template&id=53c8110b&scoped=true"
import script from "./AdminTripForm.vue?vue&type=script&lang=js"
export * from "./AdminTripForm.vue?vue&type=script&lang=js"
import style0 from "./AdminTripForm.vue?vue&type=style&index=0&id=53c8110b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8110b",
  null
  
)

export default component.exports